import React from "react";

import { QuoteBlock as Value } from "@reactivated";

import { cleanCitation, cleanQuote } from "../TestimonialCardsBlock";

import styles from "./index.module.scss";

interface Props {
    value: Value;
}

export const QuoteBlock = ({ value }: Props) => {
    return (
        <figure className={styles.root}>
            <blockquote className={styles.quote}>
                {cleanQuote(value.quote)}
            </blockquote>
            {value.citation && (
                <figcaption>
                    <p className={styles.citation}>
                        {cleanCitation(value.citation)}
                    </p>
                </figcaption>
            )}
        </figure>
    );
};
